/* ==========================================================================
   Unseen Brewing Co. — theme.js
   JS principal, vanilla ES6. Aucune dépendance.
   ========================================================================== */

/* --------------------------------------------------------------------------
   Utilitaires cookies
   -------------------------------------------------------------------------- */
const Cookies = {
  set(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  },
  get(name) {
    return document.cookie.split('; ').reduce((acc, cur) => {
      const [key, val] = cur.split('=');
      return key === name ? decodeURIComponent(val) : acc;
    }, null);
  },
};

/* --------------------------------------------------------------------------
   Modale de vérification d'âge
   -------------------------------------------------------------------------- */
function initAgeGate() {
  const gate = document.querySelector('[data-age-gate]');
  if (!gate) return;

  const COOKIE = 'unseen_age_ok';
  if (Cookies.get(COOKIE) === 'yes') return;

  const days = parseInt(gate.dataset.cookieDays, 10) || 30;
  const confirmBtn = gate.querySelector('[data-age-confirm]');
  const denyBtn = gate.querySelector('[data-age-deny]');
  const denied = gate.querySelector('[data-age-denied]');

  gate.hidden = false;
  document.body.style.overflow = 'hidden';
  confirmBtn?.focus();

  confirmBtn?.addEventListener('click', () => {
    Cookies.set(COOKIE, 'yes', days);
    gate.hidden = true;
    document.body.style.overflow = '';
  });

  denyBtn?.addEventListener('click', () => {
    if (denied) denied.hidden = false;
    confirmBtn.disabled = true;
    denyBtn.disabled = true;
  });
}

/* --------------------------------------------------------------------------
   Menu mobile
   -------------------------------------------------------------------------- */
function initMobileMenu() {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  const close = () => {
    toggle.setAttribute('aria-expanded', 'false');
    menu.removeAttribute('data-open');
    menu.hidden = true;
  };
  const open = () => {
    toggle.setAttribute('aria-expanded', 'true');
    menu.hidden = false;
    menu.setAttribute('data-open', '');
  };

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    expanded ? close() : open();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      close();
      toggle.focus();
    }
  });
}

/* --------------------------------------------------------------------------
   Mise à jour du compteur de panier (écoute les événements custom)
   -------------------------------------------------------------------------- */
function initCartCount() {
  document.addEventListener('cart:updated', (e) => {
    const count = e.detail?.item_count ?? 0;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  });
}

/* --------------------------------------------------------------------------
   Révélation au défilement (sections below-the-fold)
   -------------------------------------------------------------------------- */
function initScrollReveal() {
  const items = document.querySelectorAll('[data-reveal]');
  if (!items.length || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );
  items.forEach((el) => observer.observe(el));
}

/* --------------------------------------------------------------------------
   Filtres et tri de collection
   -------------------------------------------------------------------------- */
function initCollectionFilters() {
  const form = document.querySelector('[data-filters-form]');
  const sort = document.querySelector('[data-sort]');
  const toggle = document.querySelector('[data-filters-toggle]');
  const wrapper = document.querySelector('[data-filters]');

  const buildUrl = () => {
    const params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach((value, key) => {
        if (value) params.append(key, value);
      });
    }
    if (sort && sort.value) params.set('sort_by', sort.value);
    return `${window.location.pathname}?${params.toString()}`;
  };

  const apply = () => {
    window.location.href = buildUrl();
  };

  form?.addEventListener('change', apply);
  sort?.addEventListener('change', apply);

  toggle?.addEventListener('click', () => {
    const open = wrapper.hasAttribute('data-open');
    open ? wrapper.removeAttribute('data-open') : wrapper.setAttribute('data-open', '');
    toggle.setAttribute('aria-expanded', String(!open));
  });
}

/* --------------------------------------------------------------------------
   Initialisation
   -------------------------------------------------------------------------- */
function init() {
  initAgeGate();
  initMobileMenu();
  initCartCount();
  initScrollReveal();
  initCollectionFilters();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
